"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserDisabledCountry = void 0;
var launchpadConstants_1 = require("../../launchpadConstants");
var hooks_1 = require("../../pool/hooks");
var useUser_1 = require("../../shared/hooks/useUser");
function useUserDisabledCountry() {
    var country = (0, useUser_1.useUser)().kyc.country;
    var pool = (0, hooks_1.usePool)().pool;
    var countryName;
    try {
        var regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
        countryName = country ? regionNames.of(country) : undefined;
    }
    catch (e) {
        countryName = country;
    }
    if (!pool.kyc) {
        return { allowed: true, countryName: countryName };
    }
    var disabledCountries = (pool === null || pool === void 0 ? void 0 : pool.noCountries) || launchpadConstants_1.NO_US;
    if (!country || disabledCountries.includes(country)) {
        return { allowed: false, countryName: countryName };
    }
    // Allow when country is not found OR list is empty
    return { allowed: true, countryName: countryName };
}
exports.useUserDisabledCountry = useUserDisabledCountry;
